import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';

//UI
import { Input, Select } from "../../../../../ui/inputs/Input";
import moment from "moment";

const headCells = [
  {
    id: "mes",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Mes",
    textAlign: "center",
  },
  {
    id: "valor",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Monto Acumulado",
    textAlign: "right",
  },
  {
    id: "suelintegral",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Sueldo Integral Diario",
    textAlign: "right",
  },
  {
    id: "incivac",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Incidencia Vacaciones",
    textAlign: "right",
  },
  {
    id: "inciuti",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Incidencia Utilidades",
    textAlign: "right",
  },
];

export default function TablaAcumuGenerales(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [records, setRecords] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [formValues, setFormValues] = useState({
    valor: "0.00",
    suelintegral: "0.00",
    incivac: "0.00",
    inciuti: "0.00"
  });
  
  // Estados para los totales
  const [totales, setTotales] = useState({
    valor: "0.00",
    suelintegral: "0.00",
    incivac: "0.00",
    inciuti: "0.00"
  });
  
  const [activate, setActivate] = useState(false);
  
  // Obtener año actual
  const currentYear = moment().year();
  // Generar años desde el actual hasta 4 años atrás
  const years = [];
  for (let year = currentYear; year >= currentYear - 4; year--) {
    years.push(year);
  }
  
  const [selectedYear, setSelectedYear] = useState(currentYear);
  
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead } = useTable(
    records,
    headCells,
    { fn: items => items }
  );

  // Función para calcular totales
  const calcularTotales = (mesesData) => {
    let totalValor = 0;
    let totalSuelIntegral = 0;
    let totalIncivac = 0;
    let totalInciuti = 0;

    mesesData.forEach(mes => {
      totalValor += parseFloat(mes.valor) || 0;
      totalSuelIntegral += parseFloat(mes.suelintegral) || 0;
      totalIncivac += parseFloat(mes.incivac) || 0;
      totalInciuti += parseFloat(mes.inciuti) || 0;
    });

    setTotales({
      valor: totalValor.toFixed(2),
      suelintegral: totalSuelIntegral.toFixed(2),
      incivac: totalIncivac.toFixed(2),
      inciuti: totalInciuti.toFixed(2)
    });
  };

  const seleccionarAcumulados = (codIntegrante, año) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    
    let id = parseInt(año);
    let nomtab = `nomi${codigoNomina}.tablaacumint`;
    let nomid = 'ano';
    let nomid2 = 'codint';
    let id2 = codIntegrante;
    let orden = 1;

    let endpoint = `${op.conexion}/api/nomina/seleccionarsidstring2?id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}&orden=${orden}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
    .then(response => {
      if (response.status === 200) {
        // Crear array con todos los meses (inicialmente vacíos)
        const mesesCompletos = [
          { mes: "01", nombre: "Enero", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "02", nombre: "Febrero", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "03", nombre: "Marzo", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "04", nombre: "Abril", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "05", nombre: "Mayo", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "06", nombre: "Junio", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "07", nombre: "Julio", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "08", nombre: "Agosto", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "09", nombre: "Septiembre", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "10", nombre: "Octubre", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "11", nombre: "Noviembre", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" },
          { mes: "12", nombre: "Diciembre", valor: "0.00", suelintegral: "0.00", incivac: "0.00", inciuti: "0.00" }
        ];

        // Actualizar los meses que tienen datos
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach(item => {
            const mesIndex = mesesCompletos.findIndex(m => m.mes === item.mes);
            if (mesIndex !== -1) {
              mesesCompletos[mesIndex].valor = item.valor ? parseFloat(item.valor).toFixed(2) : "0.00";
              mesesCompletos[mesIndex].suelintegral = item.suelintegral ? parseFloat(item.suelintegral).toFixed(2) : "0.00";
              mesesCompletos[mesIndex].incivac = item.incivac ? parseFloat(item.incivac).toFixed(2) : "0.00";
              mesesCompletos[mesIndex].inciuti = item.inciuti ? parseFloat(item.inciuti).toFixed(2) : "0.00";
            }
          });
        }

        setRecords(mesesCompletos);
        calcularTotales(mesesCompletos);
        
        // Limpiar selección y valores de inputs
        setSelectedMonth(null);
        setFormValues({
          valor: "0.00",
          suelintegral: "0.00",
          incivac: "0.00",
          inciuti: "0.00"
        });
      }
    })
    .catch(error => {
      console.error("Error al cargar acumulados:", error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al cargar el registro',
        icono: 'error'
      });
    })
    .finally(() => setActivate(false));
  };

  // Manejar selección de fila
  const handleRowClick = (record) => {
    setSelectedMonth(record.mes);
    setFormValues({
      valor: record.valor,
      suelintegral: record.suelintegral,
      incivac: record.incivac,
      inciuti: record.inciuti
    });
  };

  // Manejar cambios en los inputs
  const handleInputChange = (field, value) => {
    // Permitir solo números, punto y coma
    const regex = /^[0-9]*\.?[0-9]*$/;
    if (value === '' || regex.test(value)) {
      setFormValues(prev => ({
        ...prev,
        [field]: value
      }));

      // Actualizar la tabla en tiempo real y recalcular totales
      if (selectedMonth) {
        const updatedRecords = records.map(record => 
          record.mes === selectedMonth 
            ? { ...record, [field]: value || "0.00" }
            : record
        );
        
        setRecords(updatedRecords);
        calcularTotales(updatedRecords);
      }
    }
  };

  // Manejar cambio de año
  const handleYearChange = (e) => {
    const newYear = parseInt(e.target.value);
    setSelectedYear(newYear);
    if (props.codIntegrante) {
      seleccionarAcumulados(props.codIntegrante, newYear);
    }
  };

  useEffect(() => {
    if (props.codIntegrante) {
      seleccionarAcumulados(props.codIntegrante, selectedYear);
    }
  }, [props.codIntegrante]);

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      <div className="col-3 m-0 mb-2 p-0">
        <Select 
          label="Año en Curso:" 
          value={selectedYear}
          onChange={handleYearChange}
        >
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </Select>
      </div>
      
      
      
      <div className="col-12 m-0 p-0 d-flex">
        <div className="col-9 m-0 mb-2 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records.map((item, index) => (
                <tr 
                  key={index}
                  onClick={() => handleRowClick(item)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedMonth === item.mes ? '#e3f2fd' : 'inherit'
                  }}
                >
                  <td style={{ textAlign: 'left', padding: '8px' }}>{item.nombre}</td>
                  <td style={{ textAlign: 'right', padding: '8px' }}>{item.valor}</td>
                  <td style={{ textAlign: 'right', padding: '8px' }}>{item.suelintegral}</td>
                  <td style={{ textAlign: 'right', padding: '8px' }}>{item.incivac}</td>
                  <td style={{ textAlign: 'right', padding: '8px' }}>{item.inciuti}</td>
                </tr>
              ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2 d-flex flex-column gap-2">
          <Input
            label="Monto Acumulado:"
            inputClassName="text-end"
            placeholder="0.00"
            value={totales.valor}
            onChange={(e) => handleInputChange('valor', e.target.value)}
          />
          <Input
            label="Salario Integral Diario:"
            inputClassName="text-end"
            placeholder="0.00"
            value={totales.suelintegral}
            onChange={(e) => handleInputChange('suelintegral', e.target.value)}
          />
          <Input
            label="Incidencia Vacaciones:"
            inputClassName="text-end"
            placeholder="0.00"
            value={totales.incivac}
            onChange={(e) => handleInputChange('incivac', e.target.value)}
          />
          <Input
            label="Incidencia Utilidades:"
            inputClassName="text-end"
            placeholder="0.00"
            value={totales.inciuti}
            onChange={(e) => handleInputChange('inciuti', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}